/** @format */

import * as qs from "qs"

import React, { useEffect } from "react"
import { useRelativeRouter } from "_shared/hooks/useRelativeRouter"
import URI from "urijs"
import bffClient from "_clients/BFFClient"
import { from } from "linq-to-typescript"

const Index = () => {
	const router = useRelativeRouter();


	useEffect(() => {
		const queryData = qs.parse(URI(router.asPath).query())
		const networkId = queryData.networkId

		if (networkId === undefined) {
			bffClient.networks(null).then(response => {
				if (response.result.total > 0) {
					let networkGroup = from(response.result.items)
						.where(s => s.id !== null)
						.groupBy(s => s.intermediaryNumber)
						.orderByDescending(m => m.key)
					if (networkGroup.count() > 0) {
						let networkId = networkGroup.first().first().id
						router.push(`home?networkId=${networkId}`);			
						return
					}					
				}

				router.push("home");
			})
		} else {
			router.push(`home?networkId=${networkId}`);	
		}
	},
	[router, router.asPath])
	return <></>
}

export default Index;
